/* eslint-disable */

import { State } from "./state";
import { Request } from "@/network/request";
import i18n from "../i18n";
import toast from "../plugins/toast";

export default class branches {
  endPoint = "branch";
  currentBranch = null;
  tableData = {
    data: [],
    studentsData: [],
    courseData: [],
    showData: [],
    headers: {
      id: {
        name: "id",
        keys: ["id"],
        orderable: true,
      },
      name: {
        name: "name",
        keys: ["name"],
      },
      address: {
        name: "address",
        keys: ["address"],
      },
    },
    meta: {
      total: 1,
      per_page: 1,
      current_page: 1,
    },
  };
  getState = new State();
  postState = new State();
  editState = new State();
  createState = new State();
  deleteState = new State();

  async get(params) {
    let request = new Request({
      method: "get",
      endpoint: `/${this.endPoint}`,
      params: params,
    });

    await this.getState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.tableData.data = value.data;
          this.tableData.meta = value.meta;
          if (localStorage.getItem("admin_type") == "super") {
            if (localStorage.getItem("branch")) {
              this.currentBranch = JSON.parse(localStorage.getItem("branch"));
            } else {
              this.currentBranch = value.data[0];
              localStorage.setItem("branch", JSON.stringify(value.data[0]));
            }
          }
        },
        onError: (error) => {
          toast(i18n.t(error.type), { timeout: 4000, rtl: true }, "error");
        },
      }
    );
  }

  async post(payload) {
    let request = new Request({
      method: "post",
      endpoint: `/${this.endPoint}`,
      data: payload,
      token: "44|1t0dDaKZNOPq9QZClkRdGugmJoEjAg931FghJZox",
    });

    await this.postState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          toast(
            i18n.t("create success"),
            { timeout: 4000, rtl: true },
            "sucess"
          );
        },
        onError: (error) => {
          toast(i18n.t(error.type), { timeout: 4000, rtl: true }, "error");
        },
      }
    );
  }
  async edit(payload, id, { onSuccess }) {
    let request = new Request({
      method: "put",
      endpoint: `/${this.endPoint}/${id}`,
      data: payload,
      token: "44|1t0dDaKZNOPq9QZClkRdGugmJoEjAg931FghJZox",
    });

    await this.editState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          toast(i18n.t("edit success"), { timeout: 4000, rtl: true }, "sucess");
          if (onSuccess != null) onSuccess();
        },
        onError: (error) => {
          // toast(i18n.t(error.type), { timeout: 4000, rtl: true }, "error");
        },
      }
    );
  }
  async deleteItem(id, { onSuccess }) {
    let request = new Request({
      method: "delete",
      endpoint: `/${this.endPoint}/${id}`,
      token: "44|1t0dDaKZNOPq9QZClkRdGugmJoEjAg931FghJZox",
    });

    await this.deleteState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          toast(
            i18n.t("delete success"),
            { timeout: 4000, rtl: true },
            "warning"
          );
          console.log(value);
          if (onSuccess != null) onSuccess();
        },
        onError: (error) => {
          console.log(error);
          toast(i18n.t(error.type), { timeout: 4000, rtl: true }, "error");
        },
      }
    );
  }
}

export const Branches = new branches();
